<template>
  <div class="body">
    <el-card class="box-card">
      <el-row class="title">
        <span class="titl">{{$t('Furniture.title')}}</span>
        <span class="date">{{$t('Furniture.date')}}</span>
      </el-row>

      <el-tabs v-model="tabActive" @tab-click="handleClick">
        <!--展具租赁开始 -->
        <el-tab-pane :label="$t('Furniture.exhi')" name="exhibition">
          <!-- 说明面板开始 -->
          <el-collapse v-model="foldingNames" @change="handleChange">
            <el-collapse-item name="1" class="collapse">
              <!-- 折叠头部 -->
              <template slot="title">
                <span class="instructions">{{$t('Furniture.shuoming')}}</span>
                <span class="txt"
                  >{{$t('Furniture.smContent')}}</span
                >
                <span class="folding">{{ folding }}</span>
              </template>
              <!-- 折叠体 -->
              <div class="box">
                <div class="left">
                  <img src="../../../static/greenAddress.png" alt="" />
                </div>
                <div class="right">
                  <div
                    class="font"
                    v-for="(item, index) in message"
                    :key="index"
                  >
                    <p class="title">{{ item.title }}</p>
                    <p class="txt" v-for="(i, k) in item.text" :key="k">{{ i }}</p>
                  </div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>

          <!--------------说明部分------------>
          <Furniture></Furniture>
        </el-tab-pane>

        <el-tab-pane :label="$t('Furniture.gennRent')" name="greenPlant">
          <el-collapse v-model="foldingNames" @change="handleChange">
            <el-collapse-item name="1" class="collapse">
              <!-- 折叠头部 -->
              <template slot="title">
                <span class="instructions">{{$t('Furniture.shuoming')}}</span>
                <span class="txt"
                  >{{$t('Furniture.smContent')}}</span
                >
                <span class="folding">{{ folding }}</span>
              </template>
              <!-- 折叠体 -->
              <div class="box">
                <div class="left">
                  <img src="../../../static/greenAddress.png" alt="" />
                </div>
                <div class="right">
                  <div
                    class="font"
                    v-for="(item, index) in message"
                    :key="index"
                  >
                    <p class="title">{{ item.title }}</p>
                    <p class="txt" v-for="(i, k) in item.text" :key="k">{{ i }}</p>
                  </div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
          <!-------------说明面板结束-------->
          <GreenFurniture></GreenFurniture>
        </el-tab-pane>
        <!-- 绿植部分结束 -->
      </el-tabs>
    </el-card>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import Furniture from "./planComponent/furniture.vue"; 
import GreenFurniture from "./planComponent/greenFurniture.vue"; 
export default {
  components: {
    swiper,
    swiperSlide,
    Furniture, //家具部分
    GreenFurniture, //绿植部分
  },
  data() {
    return {
      tabActive: "exhibition", //默认展开项为家具租赁
      foldingNames: ["1"], //折叠面板说明
      //说明中的折叠信息
      message: [
        {
          title: this.$t('Furniture.iphone'),
          text: [
            this.$t('Furniture.xianchang'),
            this.$t('Furniture.zhanguan'),
           this.$t('Furniture.tele'),
           this.$t('Furniture.jiandu'),
           this.$t('Furniture.email'),
          ],
        },
        {
          title: this.$t('Furniture.serviceTime'),
          text: [
            this.$t('Furniture.buzhan'),
           this.$t('Furniture.buzhanEnd'),
           this.$t('Furniture.startKai'),
          ],
        },
        {
          title:  this.$t('Furniture.serviceAddre'),
          text: [
            this.$t('Furniture.bangong'),
            this.$t('Furniture.bangong2'),
            this.$t('Furniture.bangong3'),
             this.$t('Furniture.bangong4'),
          ],
        },
      ],
      folding:this.$t('catalogue.open'), //说明下的折叠面板切换
      dialogVisible: true,
    };
  },
  methods: {
    //展具or绿植切换
    handleClick(tab, event) {
      console.log(tab, event);
    },
    //说明下的折叠面板切换函数
    handleChange(val) {
      val.length == 1 ? (this.folding = this.$t('catalogue.down')) : (this.folding = this.$t('catalogue.down'));
    },
  },

  created(){
       if(!this.$route.query.userId){
       this.$router.go(-1)
    }
  }
};
</script>
<style scoped lang="scss">
.body {
  // margin: 17px 26px 0px 26px;
  background-color: #f0f2f5;
  position: relative;
  .box-card {
    .title {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 28px;
    }
    .date {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 20px;
      margin-left: 20px;
    }
    .collapse {
      .instructions {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ff190c;
        line-height: 22px;
        margin-left: 30px;
      }
      .txt {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
      }
      .folding {
        position: absolute;
        top: 0px;
        right: 35px;
      }
      .box {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 20px;
        padding-left: 72px;
        box-sizing: border-box;
        background: #f6f6f7;
        .left {
          width: 549px;
          height: 476px;
          img {
            width: 549px;
            height: 476px;
          }
        }
        .right {
          flex: 1;
          height: 100%;
          height: 476px;

          padding-left: 30px;
          box-sizing: border-box;
          .font {
            .title {
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
              color: #333333;
              line-height: 22px;
              margin-top: 20px;
            }
            .txt {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              line-height: 20px;
              margin-top: 9px;
            }
          }
        }
      }
    }
  }
}
</style>
<style scoped>
.collapse >>> .el-collapse-item__header {
  background-color: #f6f6f7;
}
.collapse >>> .el-collapse-item__wrap {
  background-color: #f6f6f7;
}
.collapse >>> .el-collapse-item__header {
  position: relative;
}

.el-input-number {
  width: 91px;
  height: 24px;
  line-height: 24px;
}
.el-input-number >>> .el-input__inner {
  line-height: 24px !important;
  height: 24px !important;
  padding: 0px;
  border-radius: 3px;
}
.el-input-number >>> .el-input-number__decrease,
.el-input-number__increase {
  width: 24px !important;
  height: 22px !important;
}
.el-input-number >>> .el-input-number__increase {
  width: 24px !important;
  height: 22px !important;
}

.el-dialog__wrapper >>> .el-dialog__header {
  padding: 15px 20px 10px;
  background: #006fb8;
}
.el-dialog__wrapper >>> .el-dialog__title {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.el-dialog__wrapper >>> .el-dialog__close {
  color: #ffffff;
}
.el-dialog__wrapper >>> .el-dialog__body {
  padding: 20px 20px 0px 20px;
}
</style>
